export const FORMATTERS_TRANSLATION_NAMESPACE = "utils";
